import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable } from "rxjs";
import { ListResponse } from "../interfaces/list-response.interface";
import { TimeClock, UserTimeClock } from "../interfaces/timeclock.interface";

@Injectable({ providedIn: "root" })
export class TimeClockClient {
  endpoint = "timeclock";

  constructor(private httpClient: HttpClient) {}

  add(data: TimeClock) {
    return this.httpClient.post<TimeClock>(
      `${environment.endpoint}/${this.endpoint}/add`,
      data
    );
  }

  edit(data: TimeClock) {
    return this.httpClient.put<TimeClock>(
      `${environment.endpoint}/${this.endpoint}/edit`,
      data
    );
  }

  upsert(data: UserTimeClock[]) {
    return this.httpClient.post<UserTimeClock>(
      `${environment.endpoint}/${this.endpoint}/upsert`,
      data
    );
  }

  delete(id: string) {
    return this.httpClient.delete<TimeClock>(
      `${environment.endpoint}/${this.endpoint}/delete/${id}`
    );
  }

  mostRecent(): Observable<TimeClock> {
    return this.httpClient.get<TimeClock>(
      `${environment.endpoint}/${this.endpoint}/get-most-recent-current-user`
    );
  }

  getDaysTimeClocks() {
    return this.httpClient.get<ListResponse<TimeClock>>(
      `${environment.endpoint}/${this.endpoint}/list`
    );
  }

  getTimeClocksByTimeCardId(id: string) {
    return this.httpClient.get<ListResponse<TimeClock>>(
      `${environment.endpoint}/${this.endpoint}/list-by-timecard/${id}`
    );
  }
}
